import { FEATURE_FLAG_DEFAULT_VALUES, useCbhFlag } from "@src/appV2/FeatureFlags";
import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";

export function useGetShiftWithGeofenceEndThreshold(): number {
  const config = useCbhFlag(CbhFeatureFlag.AUTO_CLOCKOUT_SHIFT_END_THRESHOLD, {
    defaultValue: FEATURE_FLAG_DEFAULT_VALUES[CbhFeatureFlag.AUTO_CLOCKOUT_SHIFT_END_THRESHOLD],
  });

  return config?.shiftWithGeofenceEndThreshold ?? 6;
}
